





































































































import { Vue, Component } from 'vue-property-decorator'
import {
  MainHead,
  WingBlank,
  DialogMain,
} from '@/components/index'
import {
  UserPage,
  FreezeUser,
  UnfreezeUser,
  RegisterUser,
} from '@/api/UserAdmin'
import { Register, QueryPage } from '@/types/UserAdmin'
import { NBMessageWarning } from '@/utils/nBMessage'
@Component({
  components: {
    WingBlank,
    MainHead,
    DialogMain,
  },
})
export default class UserAdmin extends Vue {
  headTitle: string = '用户管理';
  headData: string[] = [
    '为系统设置独立的访问用户，用户分为管理员和普通用户。',
    '管理员可新增或禁用普通用户。',
  ];
  HeadImg: string = require('@/assets/images/add_object.png');

  statusArr = ['全部', '启用', '禁用'];
  statusActive = 0;

  // 模态框 dialog
  dialogVisible: boolean = false;
  dialogForm: Register = {
    account: '',
    password: '',
    isAdmin: 2,
  };
  /**
   * account 账户
   * isAdmin 是否管理员 1 是 2 否
   * status 状态 1 启用(正常) 2 禁用
   */
  form: QueryPage = {
    account: '',
    isAdmin: '',
    current: 1,
    size: 10,
  };
  /**
   * 表格信息
   */
  tableObj = {};
  /**
   * search 状态切换
   */
  handleClickStatus(idx: number) {
    this.statusActive = idx
    this.getQueryPage()
  }

  /**
   * 用户状态 switch  切换
   * status 1 启用
   * status 2 禁用
   */
  async handleSwitch(row: any) {
    if (row.status === 1) {
      await FreezeUser(row.id)
    } else {
      await UnfreezeUser(row.id)
    }

    this.getQueryPage()
  }
  /**
   * 设置 data size
   */
  handleSizeChange(val: number) {
    this.form.size = val
    this.getQueryPage()
  }
  /**
   * 设置 data  current
   */
  handleCurrentChange(val: number) {
    this.form.current = val
    this.getQueryPage()
  }

  created() {
    this.getQueryPage()
  }

  /**
   * 获取数据
   *  分页数据接口
   */
  async getQueryPage() {
    const _form: QueryPage = {
      ...this.form,
      status: !this.statusActive ? '' : this.statusActive,
    }
    const { data } = await UserPage(_form)
    this.tableObj = data
  }

  /**
   * 模态框取消
   */
  handleClose() {
    this.handleEmpty()
  }
  /**
   * 模态框确认
   */
  async handleConfirm() {
    const { account, password } = this.dialogForm
    if (account === '') {
      NBMessageWarning(this, { message: '账号不能为空' })
      return
    }
    if (password === '') {
      NBMessageWarning(this, { message: '密码不能为空' })
      return
    }
    await RegisterUser(this.dialogForm)
    this.handleEmpty()
    this.getQueryPage()
  }

  /**
   * form初始化
   * 关闭 dialog
   */
  handleEmpty() {
    this.dialogForm = {
      account: '',
      password: '',
      isAdmin: 2,
    }
    this.dialogVisible = false
  }
}
